const actions = {
  setListPictures({ commit }, listPictures) {
    commit("setListPictures", listPictures);
  },

  clearListPictures({ commit }) {
    commit("clearListPictures");
  },

  uncheckAll({ commit }) {
    commit("uncheckAll");
  },

  setPictureDetails({ commit }, picDetails) {
    commit("setPictureDetails", picDetails);
  },
};

export default actions;
